export default function Facebook() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
            <path fill='#33394d' d='M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0' />
            <g clipPath='url(#a)'>
                <g clipPath='url(#b)'>
                    <path fill='#fff' d='M13.45 23.91a12 12 0 1 0-4.35-.26l.23-.98H13z' />
                    <path
                        fill='#0866ff'
                        d='M9.1 23.65v-7.98H6.62V12H9.1v-1.58c0-4.08 1.85-5.98 5.86-5.98.76 0 2.07.15 2.6.3v3.32c-.28-.03-.77-.04-1.38-.04-1.97 0-2.73.74-2.73 2.68V12h3.92l-.67 3.67h-3.25v8.24c-1.45.18-2.93.09-4.35-.26'
                    />
                </g>
            </g>
            <defs>
                <clipPath id='a'>
                    <path fill='#fff' d='M0 0h24v24H0z' />
                </clipPath>
                <clipPath id='b'>
                    <path fill='#fff' d='M0 0h24v24H0z' />
                </clipPath>
            </defs>
        </svg>
    );
}
